module.exports = __webpack_public_path__ + "static/media/enjoy-and-share.6b371c70.jpeg";